import {QueryCondition} from './QueryCondition';

export class RowsQueryRequest
{
    constructor(
            public readonly query:QueryCondition
        )
    {}
}
